// Конфиг каналов связи с поддержкой.
// Используется меню виджета (SupportChatWidget) и блоком внутри чата (SupportChannels).
import { IconBrandTelegram, IconBrandVk, IconMail } from "@tabler/icons-react";

export const SUPPORT_CHANNELS = [
	{
		id: "telegram-support-bot",
		type: "telegram",
		label: "Telegram",
		description: "@sozvuchno_support_bot",
		href: "https://t.me/sozvuchno_support_bot",
		target: "_blank",
		Icon: IconBrandTelegram,
	},
	{
		id: "email-support-bot",
		type: "email",
		label: "E-mail",
		description: "support@sozvuchno.ru",
		href: "mailto:support@sozvuchno.ru",
		target: "_blank",
		Icon: IconMail,
	},
	{
		id: "vk-support-bot",
		type: "vk",
		label: "VK",
		description: "sozvuchno_music",
		href: "https://vk.ru/sozvuchno_music",
		target: "_blank",
		Icon: IconBrandVk,
	},
];
